"use strict";

var _classCallCheck = require("/home/gitlab-runner/builds/o6jZzivs/0/root/rf-kiln/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/gitlab-runner/builds/o6jZzivs/0/root/rf-kiln/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrokeColorUpdater = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

function updateColorValue(delta, value, valueAnimation, max, decrease) {
  var _a;

  var colorValue = value;

  if (!colorValue || !valueAnimation.enable) {
    return;
  }

  var offset = Utils_1.randomInRange(valueAnimation.offset);
  var velocity = ((_a = value.velocity) !== null && _a !== void 0 ? _a : 0) * delta.factor + offset * 3.6;

  if (!decrease || colorValue.status === Enums_1.AnimationStatus.increasing) {
    colorValue.value += velocity;

    if (decrease && colorValue.value > max) {
      colorValue.status = Enums_1.AnimationStatus.decreasing;
      colorValue.value -= colorValue.value % max;
    }
  } else {
    colorValue.value -= velocity;

    if (colorValue.value < 0) {
      colorValue.status = Enums_1.AnimationStatus.increasing;
      colorValue.value += colorValue.value;
    }
  }

  if (colorValue.value > max) {
    colorValue.value %= max;
  }
}

function updateStrokeColor(particle, delta) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

  if (!particle.stroke.color) {
    return;
  }

  var animationOptions = particle.stroke.color.animation;
  var valueAnimations = animationOptions;

  if (valueAnimations.enable !== undefined) {
    var hue = (_b = (_a = particle.strokeColor) === null || _a === void 0 ? void 0 : _a.h) !== null && _b !== void 0 ? _b : (_c = particle.color) === null || _c === void 0 ? void 0 : _c.h;

    if (hue) {
      updateColorValue(delta, hue, valueAnimations, 360, false);
    }
  } else {
    var hslAnimations = animationOptions;
    var h = (_e = (_d = particle.strokeColor) === null || _d === void 0 ? void 0 : _d.h) !== null && _e !== void 0 ? _e : (_f = particle.color) === null || _f === void 0 ? void 0 : _f.h;

    if (h) {
      updateColorValue(delta, h, hslAnimations.h, 360, false);
    }

    var s = (_h = (_g = particle.strokeColor) === null || _g === void 0 ? void 0 : _g.s) !== null && _h !== void 0 ? _h : (_j = particle.color) === null || _j === void 0 ? void 0 : _j.s;

    if (s) {
      updateColorValue(delta, s, hslAnimations.s, 100, true);
    }

    var l = (_l = (_k = particle.strokeColor) === null || _k === void 0 ? void 0 : _k.l) !== null && _l !== void 0 ? _l : (_m = particle.color) === null || _m === void 0 ? void 0 : _m.l;

    if (l) {
      updateColorValue(delta, l, hslAnimations.l, 100, true);
    }
  }
}

var StrokeColorUpdater = /*#__PURE__*/function () {
  function StrokeColorUpdater() {
    _classCallCheck(this, StrokeColorUpdater);
  }

  _createClass(StrokeColorUpdater, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      var _a, _b, _c;

      var color = particle.stroke.color;
      return !particle.destroyed && !particle.spawning && color !== undefined && (((_a = particle.strokeColor) === null || _a === void 0 ? void 0 : _a.h.value) !== undefined && color.animation.h.enable || ((_b = particle.strokeColor) === null || _b === void 0 ? void 0 : _b.s.value) !== undefined && color.animation.s.enable || ((_c = particle.strokeColor) === null || _c === void 0 ? void 0 : _c.l.value) !== undefined && color.animation.l.enable);
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateStrokeColor(particle, delta);
    }
  }]);

  return StrokeColorUpdater;
}();

exports.StrokeColorUpdater = StrokeColorUpdater;